var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_wrap"},[(_vm.endOfData && !_vm.loading)?_c('div',{staticClass:"button_style"},[_vm._v(" no more data ")]):_c('div',{staticClass:"button_style"},[_c('v-scale-transition',{attrs:{"mode":"out-in","origin":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":true,"color":"primary"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }